'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.weak-map");

require("core-js/modules/web.dom-collections.iterator");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apolloBoost = require("apollo-boost");

var _apolloCacheInmemory = require("apollo-cache-inmemory");

require("isomorphic-fetch");

var _apolloLinkHttp = require("apollo-link-http");

var _apolloLink = require("apollo-link");

var _v = _interopRequireDefault(require("uuid/v4"));

var _fragmentTypes = _interopRequireDefault(require("./fragmentTypes.json"));

var Cookies = _interopRequireWildcard(require("@lwc-ui/services/cookies"));

var SessionStorage = _interopRequireWildcard(require("@lwc-ui/services/session-storage"));

var _templateObject, _templateObject2;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var fragmentMatcher = new _apolloCacheInmemory.IntrospectionFragmentMatcher({
  introspectionQueryResultData: _fragmentTypes.default
});
var defaultClientOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore'
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all'
  },
  mutate: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all'
  }
};
/**
 * Apollo client implementation
 */

var ApiClient = /*#__PURE__*/function () {
  function ApiClient(gqlUrl, dataTransformFn) {
    var accountName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var emulation = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    (0, _classCallCheck2.default)(this, ApiClient);
    this.dataTransformFn = dataTransformFn;
    this.accountName = accountName;
    this.emulation = emulation;
    this.client = new _apolloBoost.ApolloClient({
      link: this._createLinks(gqlUrl),

      /* Apollo needs to know about the fragment that we are using in the definition
      https://www.apollographql.com/docs/react/advanced/fragments.html#fragment-matcher
      */
      cache: new _apolloCacheInmemory.InMemoryCache({
        fragmentMatcher: fragmentMatcher
      }),
      defaultOptions: defaultClientOptions
    });
  }

  (0, _createClass2.default)(ApiClient, [{
    key: "_createLinks",
    value: function _createLinks(gqlUrl) {
      var _this = this;

      // middleware link will access the jwt in the cookie and set it in the headers
      var middlewareLink = new _apolloLink.ApolloLink(function (operation, forward) {
        var jwt = _this.emulation ? SessionStorage.read('jwt_emulation') : Cookies.get("jwt");
        var correlationId = (0, _v.default)();

        if (jwt) {
          operation.setContext({
            headers: {
              jwt: jwt,
              correlationId: correlationId
            }
          });
        }

        return forward(operation);
      }); // afterware link will get the jwt value returned in the headers and set it back to the cookie

      var afterwareLink = new _apolloLink.ApolloLink(function (operation, forward) {
        return forward(operation).map(function (response) {
          return _this._afterwareLinkHeaderRetriever(response, operation);
        });
      });
      var httpLink = (0, _apolloLinkHttp.createHttpLink)({
        uri: gqlUrl
      });
      return middlewareLink.concat(afterwareLink.concat(httpLink));
    }
    /**
     * Sets the jwt to Cookie/SessionStorage and adds correlationId to response from the header
     * @param {Object} response Apollo Client responce
     * @param {Object} operation Apollo Client operation
     * @returns {Object} Responce with correlationId
     */

  }, {
    key: "_afterwareLinkHeaderRetriever",
    value: function _afterwareLinkHeaderRetriever(response, operation) {
      var _operation$getContext = operation.getContext(),
          headers = _operation$getContext.response.headers;

      if (headers) {
        var token = headers.get('jwt');
        var correlationId = headers.get('correlationId');

        if (correlationId) {
          response.correlationId = correlationId;
        }

        if (token) {
          if (this.emulation) {
            SessionStorage.write('jwt_emulation', token);
          } else {
            Cookies.set('jwt', token, 3000, this.accountName);
          }
        }
      }

      return response;
    }
    /**
     * Sends a query through the client
     * @param {string} query
     * @param {boolean} throwError When true, query will throw error if there is an error in the response
     * @returns {Object} Query response object
     */

  }, {
    key: "query",
    value: function () {
      var _query2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_query) {
        var throwError,
            response,
            dataAsModels,
            _args = arguments;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                throwError = _args.length > 1 && _args[1] !== undefined ? _args[1] : true;
                _context.next = 3;
                return this.client.query({
                  query: (0, _apolloBoost.gql)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n            ", "\n            "])), _query)
                });

              case 3:
                response = _context.sent;

                if (!(throwError && response.errors)) {
                  _context.next = 6;
                  break;
                }

                throw response.errors[0].message;

              case 6:
                dataAsModels = this.dataTransformFn ? this.dataTransformFn(response.data) : response.data; //convert to models

                return _context.abrupt("return", dataAsModels);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function query(_x) {
        return _query2.apply(this, arguments);
      }

      return query;
    }()
    /**
     * Sends a mutation through the client
     * @param {string} mutation
     * @returns {Object} Mutation response object
     */

  }, {
    key: "mutate",
    value: function () {
      var _mutate = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(mutation) {
        var response;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.client.mutate({
                  mutation: (0, _apolloBoost.gql)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n                ", "\n            "])), mutation)
                });

              case 2:
                response = _context2.sent;

                if (!response.errors) {
                  _context2.next = 5;
                  break;
                }

                throw response.errors[0].message;

              case 5:
                return _context2.abrupt("return", response.data);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function mutate(_x2) {
        return _mutate.apply(this, arguments);
      }

      return mutate;
    }()
  }, {
    key: "clear",
    value: function () {
      var _clear = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.client.clearStore();

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function clear() {
        return _clear.apply(this, arguments);
      }

      return clear;
    }()
  }]);
  return ApiClient;
}();

var _default = ApiClient;
exports.default = _default;
module.exports = exports.default;